import { Component, Input, Output, OnChanges, EventEmitter, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Models
import { CustomDataValue } from "../../model/customField.model";

// Services
import { AppMainService } from "src/app/app-main.service";
import { FileService } from "../../services/file.service";
import { MessageService } from "primeng/api";

// Constants
import { CUSTOMFIELD_TYPE_IDS } from "../../constants/typeId";

// Helpers
import { uploadFiles, validateFiles, validateFileSize } from "../../upload-files";
import { FormControlList } from "../../constants/formcontrol-list.constants";
import { AppMainComponent } from "src/app/app.main.component";
import { CurrencyService } from "../../services/currency.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TimeZoneService } from "../../services/timezone.service";
import { ImportserialService } from "../../services/importserial.service";

@Component({
    selector: 'app-shared-custom-fields',
    templateUrl: './shared-custom-fields.component.html',
    styleUrls: ['./shared-custom-fields.component.scss'],
})

export class SharedCustomFieldsComponent implements OnInit, OnChanges {
    @Input() customForm: FormGroup;
    @Input() isEdit: boolean;
    @Input() isCopy: boolean;
    @Input() templateCustomFields = [];
    @Input() customFieldValues = [];
    @Input() sectionId: number;
    @Input() tabIndex: number = 0;

    @Output() setCustomFieldValue = new EventEmitter();

    customDataValues: CustomDataValue[] = [];
    customTypes = CUSTOMFIELD_TYPE_IDS;

    uploadedFiles = [];
    uploadedPictures = [];
    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
    usersList: any[] = [];

    currencySymbol: string = "";

    multiLineTooltipPicture = `<ul class="p-mt-0 p-pl-4 p-mb-0">
        <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
        <li>Files size should not be more than 2MB</li>
    </ul>`;
    multiLineTooltipFile = `<ul class="p-mt-0 p-pl-4 p-mb-0">
      <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
      <li>Files size should not be more than 2MB</li>
    </ul>`;
    //decimal fractiondigits
    maximumFractionDigits: number = 2;
    constructor(
        private app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private currencyService: CurrencyService,
        private fileService: FileService,
        private sanitizer: DomSanitizer,
        private timezoneService: TimeZoneService,
        private importserialService: ImportserialService,
    ) {
            this.usersList = this.app.usersList;
            this.currencySymbol = this.currencyService.currencySymbolValue;
    }

    ngOnInit(): void {
        this.setFractionDigits();
    }
    
    ngOnChanges(): void {
        !this.isEdit && this.formatCustomDataValues();
        this.isCopy && this.populateCopyData();
    }

    isRequiredTouched(formControlName: string): boolean {
        const control = this.customForm?.get(formControlName);
        return control?.invalid && !control.hasError('pattern') && control?.touched;
    }

    isPatternInvalid(formControlName: string): boolean {
        const control = this.customForm?.get(formControlName);
        return control.hasError('pattern') && control?.touched;
    }

    populateCopyData(){
        this.customFieldValues.forEach(el => {
            let value = el.value;
            let findValue: any = "";
            const field = this.templateCustomFields.find(fld=> fld.customAttributeId == el.customAttributeId);

            if(field && value){
                switch (field.formControl?.type) {
                    case FormControlList.InputBox:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.DropDownList:
                        value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value) : null;
                        value = value?.name;
                        findValue = field?.formControl?.pickListValues.find(x=> x?.name==value);

                        if(findValue){
                            this.patchFormControlValue(field,findValue);
                        }
                        break;
                    case FormControlList.MultipleDropDownList:
                        value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value) : null;
                        findValue = [];
                        value?.map(x=>{
                            let xv = field?.formControl?.pickListValues.find(p=> p?.name==x?.name);
                            if(xv)findValue.push(xv);
                        })

                        if(findValue){
                            this.patchFormControlValue(field,findValue);
                        }
                        break;
                    case FormControlList.CheckBox:
                        value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value?.map(v=> v.name||v )) : null;

                        findValue = [];
                        value?.map(x=>{
                            let xv = field?.formControl?.pickListValues.find(p=> p?.name==x);
                            if(xv)findValue.push(xv.name);
                        })

                        if(findValue){
                            this.patchFormControlValue(field,findValue);
                        }

                        break;
                    case FormControlList.RadioButton:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.Rating:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.DatePicker:
                        let date = new Date(value)
                        this.patchFormControlValue(field,date);
                        break;
                    case FormControlList.DateTimePicker:
                        let dateTime = value ? this.timezoneService.showDateTimeWithZone(value,false) : '';
                        this.patchFormControlValue(field,dateTime);
                        break;
                    case FormControlList.ToggleButton:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.Number:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.Decimal:
                        this.patchFormControlValue(field,value);
                        break;
                    case FormControlList.UserLookup:
                        let userId = value ? Number(value) : value;
                        this.patchFormControlValue(field,userId);
                        break;
                    default:
                        if(![FormControlList.AutoNumber,FormControlList.EncryptedText].includes(field?.formControl?.type)){
                            this.patchFormControlValue(field,value);
                        }
                        break;
                }
            }
        });
    }

    patchFormControlValue(field: any, value: any){
        const fieldControl = this.customForm.get(field.name);
        if(fieldControl){
            fieldControl.patchValue(value);
            this.onSetCustomFieldValue(field.customAttributeId, value);
        }
    }

    formatCustomFields(): void {
        this.templateCustomFields = this.templateCustomFields.map(el => {
            return {
                labelName: el.labelName,
                fieldName: el.name||el.fieldName,
                formControlId: el.formControl?.id||el.formControlId,
                isRequired: el?.isRequired||false,
                maxLengthAfterDecimal: el?.formControl?.maxLengthAfterDecimal||el?.maxLengthAfterDecimal||null,
                currencySymbol : el?.currencySymbol||null,
            }
        });
    }

    formatCustomFieldValues(): void {
        this.customFieldValues = this.customFieldValues.map(el => {
            return {
                labelName: el.customAttribute.labelName,
                fieldName: el.customAttribute.fieldName,
                formControlId: el.customAttribute.formControlId,
                value: el.value,
                userLookupValue: el?.userLookupValue||"",
                formattedValue: el?.formattedValue||"",
                values: el.values
            };
        });
    }

    formatCustomDataValues(): void {
        this.customFieldValues = this.customFieldValues?.length>0 ? this.customFieldValues.filter(field=> field?.statusId==1) : [];
        if (this.templateCustomFields?.length && this.customFieldValues?.length) {
            this.formatCustomFields();
            this.formatCustomFieldValues();

            this.customDataValues = [];

            this.templateCustomFields.forEach(customField => {
                const { labelName, fieldName, formControlId, isRequired } = customField;

                const matchedCustomField = this.customFieldValues.find(el => el.fieldName == fieldName);

                if (matchedCustomField) {
                    this.customDataValues.push({
                        labelName,
                        fieldName,
                        formControlId,
                        value: matchedCustomField.value,
                        formattedValue: matchedCustomField?.formattedValue||"",
                        userLookupValue: matchedCustomField?.userLookupValue||"",
                        currencySymbol: customField?.currencySymbol||"",
                        isRequired
                    });
                }
            });

            this.customDataValues.forEach(el => {
                let { formControlId, value } = el;

                if (this.customTypes.DROPDOWN === formControlId) {
                    value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value) : null;
                    value = value?.name;
                } else if (this.customTypes.MULTISELECT === formControlId) {
                    value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value) : null;
                    value = value?.map(el => el.name)?.join(', ');
                } else if (this.customTypes.CHECKBOX === formControlId) {
                    value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value?.map(v=> v.name||v )) : null;
                    value = value?.join(', ');
                } else if (this.customTypes.PICTURE === formControlId || this.customTypes.FILE === formControlId) {
                    value = value ? (((typeof value === 'string') && value.length) ? JSON.parse(value) : value) : null;
                    value = value?.map(el => {
                        return {
                            name: el.name,
                            content: el.content,
                            sizeInKb: (+el.sizeInBytes / 1024).toFixed(2),
                        }
                    });
                }

                el.value = value;
            });
        }
    }

    onSetCustomFieldValue(customFieldId: number, customFieldData: any, isDate = false): void {
        if (isDate && customFieldData) {
            customFieldData = customFieldData?.toISOString();
        }

        this.setCustomFieldValue.emit({ customFieldId, customFieldData, sectionId: this.sectionId });
    }

    onCustomUpload(event, field, type): void {
        for (let file of event.files) {
            let errors = [];
            this.appMainService.isShowSpinner('upload');

            if (type == 'image') {
                errors = validateFiles(file, 2, this.allowedExtensions);
            }else{
                errors = validateFileSize(file, 2);
            }

            if (errors.length) {
                for (let error of errors) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.fileName + ": " + error.error
                    });
                }

                this.appMainService.isHideSpinner('upload');
            } else {
                uploadFiles(file, ({ name, content, size, extension }) => {
                    const dataToUpload = {
                        name,
                        content,
                        size,
                        extension
                    };

                    if (type === 'image') {
                        const foundPicture = this.uploadedPictures.find(picture => picture.name === dataToUpload.name);
                        if (!foundPicture) {
                            this.uploadedPictures.push(dataToUpload);
                            this.formatCustomPictureToForm(field);
                            field.value = this.uploadedFiles;
                            this.customForm.controls[field.name].patchValue(this.uploadedPictures);
                            this.customForm.controls[field.name].updateValueAndValidity();
                        }
                    } else {
                        const foundFile = this.uploadedFiles.find(file => file.name === dataToUpload.name);

                        if (!foundFile) {
                            this.uploadedFiles.push(dataToUpload);
                            this.formatCustomFileToForm(field);
                            field.value = this.uploadedFiles;
                            this.customForm.controls[field.name].patchValue(this.uploadedFiles);
                            this.customForm.controls[field.name].updateValueAndValidity();
                        }
                    }

                    this.appMainService.isHideSpinner('upload');
                });
            }
        }
    }

    removeCustomPicture(index, field) {
        this.uploadedPictures.splice(index, 1);
        this.formatCustomPictureToForm(field);
        field.value = this.uploadedPictures;
        this.customForm.controls[field.name].patchValue(this.uploadedPictures);
        this.customForm.controls[field.name].updateValueAndValidity();
    }

    formatCustomPictureToForm(field): void {
        const customFieldData = this.uploadedPictures.map(picture => picture.content.split('base64,')[1]);

        this.setCustomFieldValue.emit({
            customFieldId: field.customAttributeId,
            customFieldData: this.uploadedPictures,
            type: 'attachments',
            sectionId: this.sectionId
        });
    }

    removeCustomFile(index, field) {
        this.uploadedFiles.splice(index, 1);
        this.formatCustomFileToForm(field);
        field.value = this.uploadedFiles;
        this.customForm.controls[field.name].patchValue(this.uploadedFiles);
        this.customForm.controls[field.name].updateValueAndValidity();
    }

    formatCustomFileToForm(field): void {
        const customFieldData = this.uploadedFiles.map(file => file.content.split('base64,')[1]);

        this.setCustomFieldValue.emit({
            customFieldId: field.customAttributeId,
            customFieldData: this.uploadedFiles,
            type: 'attachments',
            sectionId: this.sectionId
        });
    }

    downloadFile(name, content): void {
        this.fileService.downloadFile(name, content);
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    rawHTML(content: string): SafeHtml{
        const processedContent = content.replace(/<p>\s*<\/p>/g, '<p><br></p>');
        return content ?  this.sanitizer.bypassSecurityTrustHtml(processedContent): ''
    }

    setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value||this.maximumFractionDigits;
        });
    }

}
